import React from "react"
import { Drawer, Stack, Typography, useTheme } from "@mui/material"
import Link from "next/link"

import { useRouter } from "next/router"
import auth from "../../../../../lib/auth"
import BasicLogo from "../../../../common/BasicLogo"
import { CREDIT_LAYER_ENUM } from "../../../../../services/requests/types"
import Pages from "../../../../../constants/pages"

function MobileMenuItem({ title, href, onClick }) {
  const theme = useTheme()
  return (
    <Typography
      onClick={onClick}
      textAlign='center'
      color={theme.palette.mode === "dark" ? "#fff" : "#000000"}
      variant='subtitle2'
      fontWeight='bold'
      component={href ? Link : Typography}
      href={href}
    >
      {title}
    </Typography>
  )
}
const MobileDrawer = ({ open, toggleDrawer }) => {
  const [openMenu, setOpenMenu] = React.useState(false)

  const router = useRouter()

  const handleClick = () => {
    setOpenMenu(!openMenu)
  }

  return (
    <Drawer anchor='top' open={open} onClose={toggleDrawer}>
      <Stack direction='row' justifyContent='center' py={3}>
        <BasicLogo />
      </Stack>
      <Stack direction='row' justifyContent='center' py={3}>
        <Stack spacing={3}>
          {/* <MobileMenuItem
            title='دریافت تسهیلات کولر آبی'
            href={
              auth?.isLoggedIn
                ? `/main?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`
                : `/login?backUrl=/main?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`
            }
            onClick={toggleDrawer}
          /> */}
          <MobileMenuItem title='جت کلاب' href={Pages.JetClubPlans} onClick={toggleDrawer} />
          <MobileMenuItem title='درخواست پذیرندگی' href='/merchant/request' onClick={toggleDrawer} />
          <MobileMenuItem title='درخواست تسهیلات سازمانی' href={Pages.GroupFacilities} onClick={toggleDrawer} />
          <MobileMenuItem title='سرویس های خاص' onClick={handleClick} />
          <MobileMenuItem title='پرداخت اقساط' href='/payInstallment/0' onClick={toggleDrawer} />
          {/* <Box>
            <Collapse in={openMenu} timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItemButton
                  onClick={() => {
                    toggleDrawer()
                  }}
                  sx={{ pl: 4 }}
                >
                  <ListItemText primary='استعلام خلافی های وسیله نقلیه' />
                </ListItemButton> */}
          {/* <ListItemButton
                  onClick={() => {
                    toggleDrawer()
                  }}
                  sx={{ pl: 4 }}
                >
                  <ListItemText primary='استعلام تجمیع تخلفات کلی وسیله نقلیه' />
                </ListItemButton> */}
          {/* <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام عکس تخلف خودرو' />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام پلاک های شخص' />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام وضعیت گواهینامه' />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام وضعیت پاسپورت(گذرنامه)' />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام ممنوع الخروجی' />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام کارت و سند خودرو' />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText primary='استعلام نمره منفی گواهی نامه' />
                </ListItemButton> */}
          {/* </List>
            </Collapse>
          </Box> */}
          <MobileMenuItem title='شبکه پذیرندگان' href='/merchant' onClick={toggleDrawer} />
          <MobileMenuItem title='دریافت وام' href='/main' onClick={toggleDrawer} />
          {auth.isLoggedIn ? (
            <MobileMenuItem
              title={`حساب کاربری(${auth.user?.lastName || auth.user?.firstName || auth.user?.mobileNumber || "کاربر"
                })`}
              href={Pages.Profile}
              onClick={toggleDrawer}
            />
          ) : (
            <>
              <MobileMenuItem title='ورود' href='/login' onClick={toggleDrawer} />
              <MobileMenuItem title='ثبت نام' href='/register' onClick={toggleDrawer} />
            </>
          )}
          {/* <MobileMenuItem title='ورود پذیرنده' href='/merchantLogin' onClick={toggleDrawer} /> */}
        </Stack>
      </Stack>
    </Drawer>
  )
}

export default MobileDrawer
